export type ApigeeConfig = {
	regex: RegExp;
	host: string;
	web_host: string;
	autotest_image_base_url?: string;
	client_id?: string;
	insecure?: boolean;
};

export type ApiKeys = {
	'localhost:3453'?: string;
	'api-test.anwb.nl': string;
	'api-ontw.anwb.nl': string;
	'api-acc.anwb.nl': string;
	'api.anwb.nl': string;
};

const API_KEYS: ApiKeys = {
	'localhost:3453': 'ewNAcOYxSNqt2RGf6bolKpZ6kpjtXd8X',
	'api-test.anwb.nl': 'ewNAcOYxSNqt2RGf6bolKpZ6kpjtXd8X',
	'api-ontw.anwb.nl': 'qeZcEwQt9Fn70F2BoaPHeoq9fl5FicdN',
	'api-acc.anwb.nl': 'ewNAcOYxSNqt2RGf6bolKpZ6kpjtXd8X',
	'api.anwb.nl': 'innzlrw2VjJNTsfWGaTK0C887VOO5mIJ',
};

const getApiHostname = () => makeApigeeConfig().host;

export const getApiKey = (hostname?: string, apiKeys: ApiKeys = API_KEYS): string =>
	// @ts-ignore unsafe index access was present in legacy code when converting to TS.
	apiKeys[hostname || getApiHostname()];

function makeApigeeConfig(apiKeys: ApiKeys = API_KEYS): ApigeeConfig {
	let configuration;
	// for the images of testspecifications is acc environment necessary (locally)

	const configs: ApigeeConfig[] = [
		{
			regex: /www-test/i,
			host: 'api-test.anwb.nl',
			web_host: 'www-test',
		},
		{
			regex: /local/i,
			host: 'api-test.anwb.nl',
			web_host: 'www-acc',
		},
		{
			regex: /www-ontw/i,
			host: 'api-ontw.anwb.nl',
			web_host: 'www-ontw',
		},
		{
			regex: /www-acc/i,
			host: 'api-acc.anwb.nl',
			web_host: 'www-acc',
		},
		{
			regex: /www./i,
			host: 'api.anwb.nl',
			web_host: 'www',
		},
		{
			regex: /preview./i,
			host: 'api.anwb.nl',
			web_host: 'preview',
		},
	];

	// Fallback if none works
	configuration = configuration || configs[0];

	configs.some((config) => {
		if (window.location.host.match(config.regex)) {
			configuration = config;
			return true;
		}

		return false;
	});

	if (configuration) {
		configuration.client_id = getApiKey(configuration.host, apiKeys);
	}

	return configuration;
}

export function apigeeConfig(apiKeys: ApiKeys): ApigeeConfig {
	return makeApigeeConfig(apiKeys);
}

export const apigeeConfigs = makeApigeeConfig();
